import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { searchSuratJalanApi } from "../../api/suratJalanApi";
import type { PaginationParam, PaginationResponse } from "../../types/paginationResponse";
import type { SuratJalanListItem, SuratJalanSearchFilters } from "../../types/suratJalan";

interface SuratJalanState {
  suratJalans: SuratJalanListItem[];
  loading: boolean;
  error: string | null;
  pagination: PaginationResponse | null;
}

const initialState: SuratJalanState = {
  suratJalans: [],
  loading: false,
  error: null,
  pagination: null,
};

export const searchSuratJalan = createAsyncThunk<
  { suratJalans: SuratJalanListItem[]; pagination: PaginationResponse },
  { filters?: SuratJalanSearchFilters; pagination?: PaginationParam },
  { rejectValue: string }
>("suratJalan/search", async ({ filters, pagination }, { rejectWithValue }) => {
  try {
    return await searchSuratJalanApi(filters, pagination);
  } catch (error: any) {
    return rejectWithValue(error.response?.data?.message || "Failed to search surat jalan");
  }
});

const suratJalanSlice = createSlice({
  name: "suratJalan",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(searchSuratJalan.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(searchSuratJalan.fulfilled, (state, action) => {
        state.loading = false;
        state.suratJalans = action.payload.suratJalans;
        state.pagination = action.payload.pagination;
      })
      .addCase(searchSuratJalan.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to search surat jalan";
      });
  },
});

export default suratJalanSlice.reducer;
